var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7929 13.2816C15.8642 13.2816 17.7401 14.0554 19.1861 15.3139L22 12.5V19.5347H14.9653L17.7948 16.7052C16.7084 15.7985 15.3249 15.2357 13.7929 15.2357C11.0259 15.2357 8.67318 17.0413 7.85247 19.5347L6 18.925C7.08647 15.65 10.1583 13.2816 13.7929 13.2816Z",
    fill: "#6C737F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.31c03abce1c265458a6e0c2ef44d3b53.svg";
export { ForwardRef as ReactComponent };